import React from "react";
import { useTranslation } from "react-i18next";
import { getSettings, toAppUrl } from "src/services/configService";

import { ExternalLink, PopupMenuLink } from "../NavigationLinks/NavigationLinks";

import { ListWithSubHeader } from "./ListWithSubHeader";

const ossLicensesUrl = toAppUrl("embedded/third-party");

export const HelpLinksSection = () => {
    const { t } = useTranslation(["sidepanels"]);
    const { features } = getSettings();
    const helpLinks = features.helpLinks;
    const hasAnyHelpLink =
        (helpLinks && Object.values(helpLinks).some((url) => url)) || features.pages.ossLicensesPageEnabled;

    if (!hasAnyHelpLink) {
        return null;
    }

    return (
        <ListWithSubHeader title={t("sidepanels:navigationMenu.helpdesk")}>
            <PopupMenuLink title={t("sidepanels:navigationMenu.help")} startIcon="fa-regular fa-circle-question">
                {helpLinks?.discussionForum ? (
                    <ExternalLink title={t("sidepanels:navigationMenu.discussionForum")} url={helpLinks.discussionForum} />
                ) : null}
                {helpLinks?.knowledgeBase ? (
                    <ExternalLink title={t("sidepanels:navigationMenu.knowledgeBase")} url={helpLinks.knowledgeBase} />
                ) : null}
                {helpLinks?.privacyPolicy ? (
                    <ExternalLink title={t("sidepanels:navigationMenu.privacyPolicy")} url={helpLinks.privacyPolicy} />
                ) : null}
                {helpLinks?.termsOfUse ? (
                    <ExternalLink title={t("sidepanels:navigationMenu.termsOfUse")} url={helpLinks.termsOfUse} />
                ) : null}
                {helpLinks?.legalNotice ? (
                    <ExternalLink title={t("sidepanels:navigationMenu.legalNotice")} url={helpLinks.legalNotice} />
                ) : null}
                {features.pages.ossLicensesPageEnabled ? (
                    <ExternalLink title={t("sidepanels:navigationMenu.ossLicenses")} url={ossLicensesUrl} />
                ) : null}
            </PopupMenuLink>
        </ListWithSubHeader>
    );
};
